import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Card as CardBase, Typography as TypographyBase } from '@chilecompra/react-kit/components'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const Card = styled(CardBase)`
  &.MuiPaper-root {
    box-shadow: 0 4px 10px rgba(118, 138, 162, 0.2);
    cursor: pointer;
  }
`

export const CustomTypography = styled(TypographyBase)`
  &.MuiTypography-root {
    background: ${props => props.theme.palette.blue[20]};
  }
`

export const GridContainer = styled(({ margin, minHeight, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ margin, padding, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Image = styled('img')`
  width: 100%;
  height: auto;
`

export const DialogLink = styled(({ active, width, ...props }) => <LinkBase {...props} />)`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`
export const Strong = styled('strong')``

export const Info = styled(({ justifyContent, ...props }) => <div {...props} />)`
  align-items: center;
  color: ${props => props.theme.palette.brand.black1};
  cursor: initial;
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  padding: 0 0 0 4px;
  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: center;
  }
`

export const InfoCircle = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.charts.navyBlue};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin: 0 0 0 8px;
`

export const InfoText = styled('span')``

export const ExclamationIcon = styled('div')`
  height: 16px;
  padding: 1px;
  outline: none;
  width: 16px;

  &::before {
    color: ${props => props.theme.palette.brand.white};
    content: '¡';
    display: block;
    font-size: 10px;
    line-height: 9px;
    margin-left: 0.5px;
    text-align: center;
    width: 100%;
  }
`
